import { createContext } from 'react';

const DataProviderContext = createContext({});

export default DataProviderContext;
